import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'va-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [CommonModule, MatSidenavModule, MatButtonModule, MatToolbarModule, MatIconModule],
})
export class VaNavComponent implements OnInit {
  @Input() opened: boolean;
  @Input() closeOnMobileNavigation: boolean;
  @Input() hideSideBar: boolean;
  @Input() fixedTopGap = 0; // default to 0

  /* closeEmitter renamed to adhere to MD sidenav interface, and not collide with open and close methods */
  // eslint-disable-next-line @angular-eslint/no-output-rename, @angular-eslint/no-output-native
  @Output('close') closeEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  // eslint-disable-next-line @angular-eslint/no-output-rename, @angular-eslint/no-output-native
  @Output('open') openEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;

  disableClose = true;

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (this.closeOnMobileNavigation) {
      this.disableClose = false;
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        this.close();
      });
    }
  }

  onOpen(): void {
    this.opened = true;
    this.openEmitter.emit();
  }
  onClose(): void {
    this.opened = false;
    this.closeEmitter.emit();
  }

  open(): void {
    this.sidenav.open();
  }

  /* Closes the nav (only on mobile) */
  close(): void {
    this.sidenav.close();
  }
}
